/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'litecoin': {
    width: 49,
    height: 49,
    viewBox: '0 0 49 49',
    data: '<g _fill="none" fill-rule="evenodd"><circle pid="0" cx="24.5" cy="24.5" r="24.5" _fill="#D7D7D7"/><path pid="1" _fill="#FFF" d="M23.11 32.502H31L30.78 34h-9.325v-7.794l-1.793 1.11L19 26.233l2.428-1.526.027-.028V15h1.655v8.654l4.966-3.107.69 1.082-5.656 3.523z"/></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/compiled-icons/litecoin.js